// Profile action types

const profileActionTypes = {
  GET_PROFILE_USER: 'GET_PROFILE_USER',
  GET_PROFILE_USER_SUCCESS: 'GET_PROFILE_USER_SUCCESS',
  GET_PROFILE_USER_ERROR: 'GET_PROFILE_USER_ERROR',
  LOGOUT_PROFILE: 'LOGOUT_PROFILE',
  UPDATE_PROFILE: 'UPDATE_PROFILE',
  UPDATE_PROFILE_SUCCESS: 'UPDATE_PROFILE_SUCCESS',
  UPDATE_PROFILE_ERROR: 'UPDATE_PROFILE_ERROR',
  AFTER_UPDATE_PROFILE_SUCCESS: 'AFTER_UPDATE_PROFILE_SUCCESS'
};

export default profileActionTypes;
